import React from "react";

const Owner = React.lazy(() => import("../pages/home/owner/Owner"));
const SchoolList = React.lazy(() => import("../pages/list/SchoolList"));
const NewSchool = React.lazy(() => import("../pages/school/NewSchool"));
const EditSchool = React.lazy(() => import("../pages/school/EditSchool"));
const UserList = React.lazy(() => import("../pages/list/UserList"));
const EditUser = React.lazy(() => import("../pages/user/EditUser"));
const TemplateList = React.lazy(() => import("../pages/list/TemplateList"));
const NewTemplate = React.lazy(() => import("../pages/template/NewTemplate"));
const EditTemplate = React.lazy(() => import("../pages/template/EditTemplate"));
const Notifications = React.lazy(
  () => import("../pages/notifications/Notifications"),
);
const Messages = React.lazy(() => import("../pages/messages/Messages"));
const LeadInbox = React.lazy(() => import("../pages/home/owner/LeadInbox"));
const Billing = React.lazy(() => import("../pages/billing/Billing"));
const Gallery = React.lazy(() => import("../pages/home/owner/Gallery"));

export const ownerRoutes = [
  {
    path: "/enquiries",
    element: <LeadInbox />,
    title: "Enquiries",
    description:
      "Follow up on public website contact messages and demo requests.",
  },
  {
    path: "/messages",
    element: <Messages />,
    title: "Messages",
    description:
      "Have private, real-time conversations with your school community.",
    allowedRoles: [
      "appOwner",
      "admin",
      "teacher",
      "receptionist",
      "parent",
      "student",
      "principal",
      "manager",
      "coordinator",
    ],
  },
  {
    path: "/notifications",
    element: <Notifications />,
    title: "Notifications",
    description: "Send and receive important school updates.",
    allowedRoles: [
      "appOwner",
      "admin",
      "teacher",
      "receptionist",
      "parent",
      "student",
      "principal",
      "manager",
      "coordinator",
    ],
  },
  {
    path: "/owner",
    element: <Owner />,
    title: "Owner Dashboard",
    description: "Manage your school as the app owner",
  },
  {
    path: "/billing",
    element: <Billing />,
    title: "Owner Billing",
    description: "Record school payments, upgrades, and receipts.",
    allowedRoles: ["appOwner"],
  },
  {
    path: "/gallery",
    element: <Gallery />,
    title: "Media Gallery",
    description: "Browse uploaded photos and school logos.",
    allowedRoles: ["appOwner"],
  },
  {
    path: "/schools",
    element: <SchoolList />,
    title: "School List",
    description: "View and manage schools",
  },
  {
    path: "/schools/new",
    element: <NewSchool />,
    title: "Register New School",
    description: "",
  },
  {
    path: "/schools/:schoolId",
    element: <EditSchool />,
    title: "Edit School",
    description: "",
  },
  {
    path: "/users",
    element: <UserList />,
    title: "User List",
    description: "",
  },
  {
    path: "/users/:userId",
    element: <EditUser />,
    title: "Edit User",
    description: "",
    allowedRoles: [
      "appOwner",
      "admin",
      "teacher",
      "receptionist",
      "coordinator",
      "manager",
      "principal",
      "operator",
    ],
    requiredPermission: "usersView",
  },
  {
    path: "/templates",
    element: <TemplateList />,
    title: "Template List",
    description: "",
  },
  {
    path: "/templates/new",
    element: <NewTemplate />,
    title: "Create New Template",
    description: "",
  },
  {
    path: "/templates/:templateId",
    element: <EditTemplate />,
    title: "Edit Template",
    description: "",
  },
];
